import { render, staticRenderFns } from "./PartsCatalogueSideMenu.vue?vue&type=template&id=e3d4d1ca&scoped=true"
import script from "./PartsCatalogueSideMenu.vue?vue&type=script&lang=js"
export * from "./PartsCatalogueSideMenu.vue?vue&type=script&lang=js"
import style0 from "./PartsCatalogueSideMenu.vue?vue&type=style&index=0&id=e3d4d1ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d4d1ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3d4d1ca')) {
      api.createRecord('e3d4d1ca', component.options)
    } else {
      api.reload('e3d4d1ca', component.options)
    }
    module.hot.accept("./PartsCatalogueSideMenu.vue?vue&type=template&id=e3d4d1ca&scoped=true", function () {
      api.rerender('e3d4d1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/partscatalogue/PartsCatalogueSideMenu.vue"
export default component.exports